/* list */
import { Component, Input } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { FcinputComponent } from '../fcinput';
import { Sysappfields, Sysappbuttons } from 'fccore2';
import { CommonService } from 'fccore2';
/**
 * fc-liståè¡¨
 * 
 * éç¨åè¡¨ã
 * 
 * æåºç¡çåè¡¨å±ç¤ºï¼å¯æ¿è½½æå­ãåè¡¨ãå¾çãæ®µè½ï¼å¸¸ç¨äºåå°æ°æ®å±ç¤ºé¡µ	é¢ã
 * 
 */
@Component({
    selector: 'fc-list',
    template: `
<nz-list
    class="fc-list"
    [nzDataSource]="fcData"
    [nzItemLayout]="'horizontal'"
    [nzRenderItem]="item">
    <ng-template #item let-item>
      <nz-list-item class="fc-list-item" [ngClass]="{'active':_isActive(item.ID)}" [nzContent]="item[fcField.LENGTH]" [nzActions]="[buttons]" (click)="_select(item); event('select',item)">
        <ng-template #buttons>
            <ng-container *ngFor="let btn of _buttons">
                <i nz-icon [iconfont]="btn.BTNICON" [title]="btn.BTNNAME"
                    *ngIf="btn.BTNICON!==undefined&&btn.BTNICON!==null&&btn.BTNICON!==''"
                    (click)="$event.stopPropagation();event(btn.ACTCODE, item)"></i>
                <span class="borderRighgt" *ngIf="btn.BTNICON===undefined||btn.BTNICON===null||btn.BTNICON===''" (click)="$event.stopPropagation();event(btn.ACTCODE,
                     item)">{{btn.BTNNAME}}</span>
            </ng-container>
        </ng-template>
        <nz-list-item-meta
            [nzTitle]="nzTitle"
            [nzAvatar]="item[fcIconCode]"
            [nzDescription]="item[fcSubTitleCode]">
            <ng-template #nzTitle>
                <div *ngIf="item[fcIconCode]!==undefined&&item[fcIconCode]!==null&&item[fcIconCode]!==''" class="icon-circle" [style.backgroundColor]="fcIconColor">
                    <i class="icon iconfont left-icon" nz-icon [iconfont]="item[fcIconCode]"></i>
                </div>
                <div *ngIf="fcIcon!==undefined&&fcIcon!==null&&fcIcon!==''" class="icon-circle" [style.backgroundColor]="fcIconColor">
                    <i class="icon iconfont left-icon" nz-icon  [iconfont]="fcIcon"></i>
                </div> 
                <a href="javascript:;">{{item[fcField.FIELDCODE]}}</a>
            </ng-template>
        </nz-list-item-meta>
      </nz-list-item>
    </ng-template>
  </nz-list>
    `,
    styles: [`
      :host ::ng-deep .loadmore {
        text-align: center;
        margin-top: 12px;
        height: 32px;
        line-height: 32px;
      }
      .icon-circle{
        width:30px;
        height:30px;
        line-height:30px;
        background-color:#46be8a;
        border-radius:50%;
        text-align:center;
        float:left;
        margin:0px 10px;
        color:#ffffff;
        .borderRighgt{
            border-right:1px solid #e8e8e8;
            padding-right: 5px;
        }
        .borderRighgt:hover{
            color:#1692ff;
        }
        .fc-list-item:hover,.active{
            background-color:#F3F7F9;
            cursor:pointer;
        }
        :host ::ng-deep .fc-list-item:hover .ant-list-item-meta-title>a,:host ::ng-deep .active .ant-list-item-meta-title>a {
            color:rgb(24, 144, 255);
        }
    `]
})
export class FclistComponent extends FcinputComponent {
    // è¿æ­£å¨å è½½ä¸­
    loading: boolean = false;
    data = [];
    /** åè¡¨æé®åçåå®¹ */
    @Input()
    fcContent: string;
    /** å¤´å */
    @Input()
    fcAvatar: string;
    /** åå¾æ  */
    @Input()
    fcIconCode: string;
    /** åºå®å¾æ  */
    @Input()
    fcIcon: string;
    /** å¾æ é¢è² */
    @Input()
    fcIconColor: string;
     _buttons: any[];
    /** ç¶æ */
    @Input()
    fcStatus: string;
    /** æ é¢ */
    @Input()
    fcTitle: string;
    /** éä¸­id */
    @Input()
    fcSelectedId: string;
    /** å°æ é¢ */
    @Input()
    fcSubTitleCode: string;
    /**éä¸­å¼*/
    @Input()
    fcCheckValue: any;
    @Input()
    fcStatusCode: string;
    _isVisible: boolean = false;
    /**æ¯å¦éæ©æ¡*/
    @Input()
    /**éä¸­æcheckbox*/
    fcEnableCheckbox: string;
    /**å¤éæ¡éä¸­*/
    _isCheckedButton: boolean = false;
    constructor(public provider: ProvidersService) {
        super(provider, 'fc-list');
        this.fcData = [];
        this.fcOption = { field: {}, data: [], buttons: [] };
    }
    _afterParentInit() {
        if (this.fcEnableCheckbox === undefined) {
            this.fcEnableCheckbox = 'N';
        }
        if (this.fcOption instanceof Array) {
            this.fcData = this.fcOption;
            this.fcData.forEach(el => {
                let title = CommonService.getStringFilterByParam(el, ":{APPID}:{APPID}")
            });
            this.fcField = this.fcApp.SYSAPPFIELDS.filter(field => this.fcFieldCode === field.FIELDCODE)[0];
            this._buttons = this.fcApp.SYSAPPBUTTONS.filter(btn => btn.BTNTYPE === 'LISTONE');
            this.event('loaded', this.fcData);
        } else {
            this.fcField = this.fcApp.SYSAPPFIELDS.filter(field => this.fcOption.field.FIELDCODE === field.FIELDCODE)[0];
            if (this.fcOption.buttons === undefined || this.fcOption.buttons.length === 0) {
                this._buttons = this.fcApp.SYSAPPBUTTONS.filter(btn => btn.BTNTYPE === 'LISTONE');
            }
            if (this.fcOption.data === undefined || this.fcOption.data.length === 0) {
                let condition = {};
                if (this.fcCondition && this.fcCondition.length > 0) {
                    try {
                        condition = JSON.parse(this.fcCondition);
                    } catch (e) { }
                }
                // this.loading = true;
                this.pushDestroy(this.appService.findWithQuery(this.fcAppid, condition).subscribe(result => {
                    if (result.CODE === '0') {
                        this.event('loaded', result.DATA);
                        this.fcData = result.DATA;
                        // this.loading = false;
                    }
                }));
            }
        }
    }
    /**
     * éä¸­
     * @param item 
     */
    _select(item) {
        return this.fcSelectedId = item.ID;
    };

    /**
     * æ¿æ´» 
     * @param id 
     */
    _isActive(id) {
        return this.fcSelectedId === id;
    };


}
export interface FclistOption {
    field: Sysappfields; /** Sysappfields;*/
    data?: any[]; /**åå®¹*/
    buttons?: Sysappbuttons[]; /**æä½*/
}
